module.exports = __webpack_public_path__ + "static/media/life.e0bddbc4.svg";